export default class kitchenitemsManager {
    constructor(pageID,param) {

        /* 必要なDOM */
        this.movieWrap = document.getElementById('p-kv__movie');
        this.movie = document.getElementById('p-kv__movie-video');

        this.kv = document.getElementById('p-kv');
        this.kvBg = document.getElementById('p-kv__bg');

        //cookie
        var expire = new Date();
        expire.setTime(expire.getTime() + 1000 * 3600 * 24);

        if (pageID === 'magnettrivet') {
            if (this.getCookie('magnettrivet') > 0) {
                let _cookie = parseInt(this.getCookie('magnettrivet')) + parseInt(1);
                document.cookie = 'magnettrivet=' + _cookie + '';
            } else {
                document.cookie = 'magnettrivet=1; expires=' + expire.toUTCString() + '';
            }
        } else if (pageID === 'apron_and_cloth') {
            if (this.getCookie('apron_and_cloth') > 0) {
                let _cookie = parseInt(this.getCookie('apron_and_cloth')) + parseInt(1);
                document.cookie = 'apron_and_cloth=' + _cookie + '';
            } else {
                document.cookie = 'apron_and_cloth=1; expires=' + expire.toUTCString() + '';
            }
        }

        this.param = param;
        this.pageID = pageID;

        this.slideCount = 1;

        if (this.param.userAgent === 'sp' && pageID === 'magnettrivet' || this.param.userAgent === 'sp' && pageID === 'apron_and_cloth') {
            setTimeout(() => {
                this.kvFade();
            },2e3);
        }
    }

    init(){

        if(this.param.userAgent === 'sp') return;

        let source = document.createElement('source');
        source.setAttribute('type', 'video/mp4');

        if(this.pageID === 'magnettrivet'){
            if(parseInt(this.getCookie('magnettrivet')) % parseInt(2) === 0){
                source.setAttribute('src', '/assets/img/products/kitchenitems/magnettrivet/kv2.mp4');
                document.body.classList.add('type2');
            }else{
                source.setAttribute('src', '/assets/img/products/kitchenitems/magnettrivet/kv.mp4');
            }
        }else if(this.pageID === 'hk_and_ph'){
            source.setAttribute('src', '/assets/img/products/kitchenitems/hk_and_ph/kv.mp4');
        }else if(this.pageID === 'apron_and_cloth'){
            if(parseInt(this.getCookie('apron_and_cloth')) % parseInt(2) === 0){
                source.setAttribute('src', '/assets/img/products/kitchenitems/apron_and_cloth/kv2.mp4');
                document.body.classList.add('type2');
            }else{
                source.setAttribute('src', '/assets/img/products/kitchenitems/apron_and_cloth/kv.mp4');
            }
        }

        this.movie.appendChild(source);

    }

    getCookie(name) {

        var result = null;

        var cookieName = name + '=';
        var allcookies = document.cookie;

        var position = allcookies.indexOf( cookieName );
        if( position != -1 )
        {
            var startIndex = position + cookieName.length;

            var endIndex = allcookies.indexOf( ';', startIndex );
            if( endIndex == -1 )
            {
                endIndex = allcookies.length;
            }

            result = decodeURIComponent(
                allcookies.substring( startIndex, endIndex ) );
        }

        return result;

    }

    kvFade(){

        TweenMax.to(this.kvBg, 0.9, {
            delay:3,
            display: 'none',
            opacity: 0,
            ease: Power2.easeOut,
            onComplete: () =>{
                this.kvBg.classList.remove('type'+this.slideCount);
                if(this.slideCount === 2){
                    this.slideCount = 1;
                }else{
                    this.slideCount = 2;
                }
                this.kvBg.classList.add('type'+this.slideCount);
                TweenMax.to(this.kvBg, 0.6, {
                    display: 'block',
                    opacity: 1,
                    ease: Power2.easeIn,
                    onComplete:()=>{
                        this.kvFade();
                    }
                });
            }
        })

    }

}
